import React, { useEffect, useState } from "react";

import { CSSProvider } from "@perfectserve/css-styles-react";

import { createPendoConfigFromByIdentityId } from "@/utils/pendoMapper";

import { useUser } from "../hooks";
import { useAppAuth } from "../hooks/useAppAuth";

import "../components/UserSettings.css";

const HumanPage = () => {
  const { user, selectedRole } = useUser();
  const { isAuthenticated, permissions, isPerfectServeUser } = useAppAuth();
  const [userConfiguration, setUserConfiguration] = useState<any>(null);
  const [pendoSubmissionData, setPendoSubmissionData] = useState<any>(null);

  useEffect(() => {
    if (isAuthenticated) {
      // Get UserConfiguration from global window object
      const userConfig = (window as any).PSX_USER_CONFIGURATION;
      setUserConfiguration(userConfig);

      // Get the actual Pendo submission data (what we send to Pendo)
      if (user && selectedRole) {
        try {
          // Get the actual submission data using the imported function
          const pendoConfig = createPendoConfigFromByIdentityId(user, selectedRole);
          setPendoSubmissionData(pendoConfig);
        } catch (_error) {
          // Silently handle Pendo data loading errors
        }
      }
    }
  }, [isAuthenticated, user, selectedRole]);

  const renderObject = (obj: any, title: string) => {
    if (!obj) {
      return (
        <div className="card">
          <div className="card-header">{title}</div>
          <div className="card-body">
            <p className="text-muted italic">No data available</p>
          </div>
        </div>
      );
    }

    return (
      <div className="card">
        <div className="card-header">{title}</div>
        <div className="card-body">
          <pre className="user-settings-data-container">{JSON.stringify(obj, null, 2)}</pre>
        </div>
      </div>
    );
  };

  return (
    <CSSProvider>
      <div className="pt-30" style={{ maxWidth: "800px", margin: "0 auto" }}>
        {/* Permissions Section */}
        <div className="card">
          <div className="card-header">User Settings & Data</div>
          <div className="card-body">
            <div>
              <strong>PerfectServe User:</strong>{" "}
              <span className={isPerfectServeUser ? "text-success" : "text-muted"}>
                {isPerfectServeUser ? "Yes" : "No"}
              </span>
            </div>
            <div className="mt-20">
              <strong>Permissions ({permissions.length}):</strong>
              {permissions.length > 0 ? (
                <ul className="user-settings-permissions-list">
                  {permissions.map((permission, index) => (
                    <li key={index} className="user-settings-permissions-item">
                      {permission}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-muted italic" style={{ margin: "0.5rem 0 0 0" }}>
                  No permissions loaded
                </p>
              )}
            </div>
          </div>
        </div>

        {/* User Configuration Section */}
        {renderObject(userConfiguration, "User Configuration")}

        {/* Pendo Submission Data Section */}
        {renderObject(pendoSubmissionData, "Pendo Analytics Data")}
      </div>
    </CSSProvider>
  );
};

export default HumanPage;
